import { render, staticRenderFns } from "./matchMapping.vue?vue&type=template&id=4cf6c7f8&scoped=true"
import script from "./matchMapping.vue?vue&type=script&lang=js"
export * from "./matchMapping.vue?vue&type=script&lang=js"
import style1 from "./matchMapping.vue?vue&type=style&index=1&id=4cf6c7f8&prod&lang=scss&scoped=true"
import style2 from "./matchMapping.vue?vue&type=style&index=2&id=4cf6c7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6c7f8",
  null
  
)

export default component.exports